import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=7615c97f&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"
import style0 from "./Nav.vue?vue&type=style&index=0&id=7615c97f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7615c97f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Input.vue').default,MenuItem: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/MenuItem.vue').default,LanguageList: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Language/LanguageList.vue').default,Nav: require('D:/somyshare/libraries/source-code/templates-collection/m29_yuaoshengwu/components/Nav.vue').default})
